// extracted by mini-css-extract-plugin
export default {"Category":"Category--ad31fc5"};